/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsMemberServiceFilterLogic } from './WebApiServicesDataTransferObjectsMemberServiceFilterLogic';
import {
    WebApiServicesDataTransferObjectsMemberServiceFilterLogicFromJSON,
    WebApiServicesDataTransferObjectsMemberServiceFilterLogicFromJSONTyped,
    WebApiServicesDataTransferObjectsMemberServiceFilterLogicToJSON,
} from './WebApiServicesDataTransferObjectsMemberServiceFilterLogic';
import type { WebApiServicesDataTransferObjectsMemberServiceFilterOperator } from './WebApiServicesDataTransferObjectsMemberServiceFilterOperator';
import {
    WebApiServicesDataTransferObjectsMemberServiceFilterOperatorFromJSON,
    WebApiServicesDataTransferObjectsMemberServiceFilterOperatorFromJSONTyped,
    WebApiServicesDataTransferObjectsMemberServiceFilterOperatorToJSON,
} from './WebApiServicesDataTransferObjectsMemberServiceFilterOperator';

/**
 * Represents a single filter criteria for member queries
 * @export
 * @interface WebApiServicesDataTransferObjectsMemberServiceFilterCriteria
 */
export interface WebApiServicesDataTransferObjectsMemberServiceFilterCriteria {
    /**
     * The field name to filter on (e.g., "Email", "FirstName", "CustomField_5")
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsMemberServiceFilterCriteria
     */
    fieldName?: string | null;
    /**
     * 
     * @type {WebApiServicesDataTransferObjectsMemberServiceFilterOperator}
     * @memberof WebApiServicesDataTransferObjectsMemberServiceFilterCriteria
     */
    operator?: WebApiServicesDataTransferObjectsMemberServiceFilterOperator;
    /**
     * The value to compare against
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsMemberServiceFilterCriteria
     */
    value?: string | null;
    /**
     * 
     * @type {WebApiServicesDataTransferObjectsMemberServiceFilterLogic}
     * @memberof WebApiServicesDataTransferObjectsMemberServiceFilterCriteria
     */
    logic?: WebApiServicesDataTransferObjectsMemberServiceFilterLogic;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsMemberServiceFilterCriteria interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsMemberServiceFilterCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsMemberServiceFilterCriteriaFromJSON(json: any): WebApiServicesDataTransferObjectsMemberServiceFilterCriteria {
    return WebApiServicesDataTransferObjectsMemberServiceFilterCriteriaFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsMemberServiceFilterCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsMemberServiceFilterCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldName': !exists(json, 'fieldName') ? undefined : json['fieldName'],
        'operator': !exists(json, 'operator') ? undefined : WebApiServicesDataTransferObjectsMemberServiceFilterOperatorFromJSON(json['operator']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'logic': !exists(json, 'logic') ? undefined : WebApiServicesDataTransferObjectsMemberServiceFilterLogicFromJSON(json['logic']),
    };
}

export function WebApiServicesDataTransferObjectsMemberServiceFilterCriteriaToJSON(value?: WebApiServicesDataTransferObjectsMemberServiceFilterCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldName': value.fieldName,
        'operator': WebApiServicesDataTransferObjectsMemberServiceFilterOperatorToJSON(value.operator),
        'value': value.value,
        'logic': WebApiServicesDataTransferObjectsMemberServiceFilterLogicToJSON(value.logic),
    };
}

